import { FIELD_TYPES } from "constants/template-field-type";
import VerticalTabsFieldsConfig from "segments/desktop/core-components/vertical-tabs/fields-config";
import AssetFieldsConfig from "components/core/asset/fields-config";
import FullParagraphFieldsConfig from "segments/desktop/core-components/full-paragraph/fields-config";

const { backgroundColor, theme, tabsColor, tabs, title, ...restOfConfig } = VerticalTabsFieldsConfig;
const { topic, buttonConfig, textAlign, body, textColor, titleColor, color, ...restOfParagraphFields } =
  FullParagraphFieldsConfig;

export default {
  type: FIELD_TYPES.NESTED,
  label: "Timeline",
  fields: {
    theme,
    tabsColor,
    lineColor: {
      type: FIELD_TYPES.COLOR_PICKER,
      label: "Menu line Color"
    },
    ...restOfConfig,
    titles: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Tabs Title",
      maxLimit: 4,
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          tabsTitle: { type: FIELD_TYPES.TEXT, label: "Tabs title" },
          tabs: {
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 8,
            nestedConfig: {
              type: FIELD_TYPES.NESTED,
              fields: {
                tabLabel: { type: FIELD_TYPES.TEXT, label: "Tab Label", translatable: true },
                title: {
                  type: FIELD_TYPES.NESTED,
                  label: "Asset text",
                  fields: restOfParagraphFields
                },
                asset: {
                  type: FIELD_TYPES.NESTED,
                  label: "Asset",
                  fields: {
                    assetVerticalPadding: {
                      type: FIELD_TYPES.TEXT,
                      label: "Asset Vertical padding",
                      translatable: true
                    },
                    ...AssetFieldsConfig
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};
